import DashboardTemplate from "components/templates/DashboardTemplate/DashboardTemplate";

const DashboardPage = () => {
  return <DashboardTemplate />;
};

export default DashboardPage;
